import { useState } from 'react';
import { Container, Dropdown, Nav, Navbar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import chevronDown from '../../assets/chevron-down.svg';
import searchCommerceIcon from '../../assets/Consumption-management.svg';
import logo from '../../assets/logo-getnet-full@2x.png';
import logoutIcon from '../../assets/LogoutIcon.svg';
import myOnboardingsIcon from '../../assets/MyOnboardingsIcon.svg';
import profileIcon from '../../assets/ProfileIcon.svg';
import Logout from '../../screens/Logout/Logout';
import { pagesPaths } from '../../utils/navigationUtils';

function Header() {
  const fullName = localStorage.getItem('fullName') || '';
  const [show, setShow] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <Navbar expand="lg" sticky="top">
      <Container className="px-lg-0">
        <Navbar.Brand>
          <Nav.Link className="p-0" href={pagesPaths.SearchCommerce}>
            <img src={logo} alt="Getnet" width={115} />
          </Nav.Link>
        </Navbar.Brand>
        <Nav>
          <Dropdown align="end" className="user-menu">
            <Dropdown.Toggle as="button" type="button" bsPrefix="user-menu-toggle" id="user-menu-toggle">
              <img src={profileIcon} alt="" className="user-menu-profile-icon" />
              <span className="user-menu-name d-none d-md-inline">{fullName}</span>
              <img src={chevronDown} alt="" className="user-menu-chevron" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => navigate(pagesPaths.SearchCommerce)}>
                <img src={searchCommerceIcon} alt="" className="user-menu-item-icon" />
                Búsqueda del comercio
              </Dropdown.Item>
              <Dropdown.Item onClick={() => navigate(pagesPaths.MyOnboardings)}>
                <img src={myOnboardingsIcon} alt="" className="user-menu-item-icon" />
                Mis onboardings
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => setShow(true)}>
                <img src={logoutIcon} alt="" className="user-menu-item-icon" />
                Cerrar sesión
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
        <Logout setShow={setShow} show={show} />
      </Container>
    </Navbar>
  );
}

export default Header;
